// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"3183b54f","457":"611551a8"}[chunkId] + ".chunk.js";
};